/**
 * JavaScript obsluhující přidání do košíku z detailu produktu
 */

if (ID['add-cart']) {
    [...document.getElementsByClassName('size'), ...document.getElementsByClassName('color')].forEach(el => {
        el.addEventListener('change', e => {
            let size, color;
            if (e.target.dataset.variantType === 'sizes') {
                size = e.target.value;
                if (document.querySelector('input[name="color"]:checked')) {
                    color = document.querySelector('input[name="color"]:checked').value;

                }

                if (document.querySelector('select[name="color"]')) {
                    color = document.querySelector('select[name="color"]').value;

                }

            } else {
                color = e.target.value;

                if (document.querySelector('input[name="size"]:checked')) {
                    size = document.querySelector('input[name="size"]:checked').value;

                }

                if (document.querySelector('select[name="size"]')) {
                    size = document.querySelector('select[name="size"]').value;

                }
            }

            if (size === '' && color === '') {
                ID['selected-variant'].style.display = 'none';

            }

            naja.makeRequest(
                'GET',
                e.target.dataset.link,
                {
                    'addCart-size': size,
                    'addCart-color': color,
                    'addCart-getVariantData': true
                },
                {
                    history: false
                }
            ).then(r => {
                const
                    variant = r.variantData ? r.variantData : r,
                    values = variant.values;

                if (
                    _.isNull(document.querySelector('select[name="color"]'))
                    && _.isNull(document.querySelector('select[name="size"]'))
                ) {
                    disableCheckbox(variant.variant, values);

                } else {
                    disableSelectOption(variant.variant, values);

                }

                ID['amount-' + r.productId].dataset.variantAvailability = r.availabilityVariant;

                /*if (ID['addToCart'].hasAttributes('disabled')) {
                    ID['addToCart'].removeAttribute('disabled');

                }*/

                if (r.availability === 0) {
                    ID['addToCart'].setAttribute('disabled', true);

                }

                if (!_.isEmpty(r.size) && !_.isNull(ID['select-size'])) {
                    ID['select-size'].textContent = r.size;

                }

                if (!_.isEmpty(r.color) && !_.isNull(ID['select-color'])) {
                    ID['select-color'].textContent = r.color;

                }

                let sizesError = document.querySelector('.size-wrapp .error');
                if (!_.isNull(sizesError)) {
                    sizesError.hidden = true;

                }


                if (ID['reservation-error']) {
                    if (
                        document.querySelector('input[name="color"]:checked') &&
                        document.querySelector('input[name="size"]:checked')
                    ) {
                        ID['reservation-error'].classList.add('d-none');

                    }

                }

            });

        })

    });

    const disableSelectOption = (type, values) => {
        [...document.querySelectorAll('select[name="' + type + '"]')].forEach(el => {
            [...el.options].forEach(option => {
                option.disabled = option.value && !values.includes(option.value);

            });

        });

    }

    const disableCheckbox = (type, values) => {
        const elements = type === 'color'
            ? document.querySelectorAll('input[data-selector]')
            : document.querySelectorAll('label[data-selector]');

        [...elements].forEach(el => {
            if (type === 'color') {
                el.disabled = !values.includes(el.value);
                if (el.checked && el.disabled) {
                    el.checked = false;

                }

            } else {
                const radio = el.querySelector('input[type=radio]');
                radio.disabled = !values.includes(radio.value);
                if(radio.disabled) {
                    el.classList.add('disabled');

                } else {
                    el.classList.remove('disabled');

                }

            }

        })
    };

    if (document.getElementsByClassName('amount-input')) {
        [...document.getElementsByClassName('amount-input')].forEach(el => {
            el.oninput = (e) => {
                if (!_.isEmpty(el.value)) {
                    if (_.isUndefined(el.dataset.type)) {
                        FNC.addCart.setCount(el, null, true);

                    } else {
                        FNC.addCart.setCountCoefficient(el, null, true);

                    }

                }

            };

        });

    }


    /*let color = document.querySelectorAll(".colors input");
    if (color.length === 1) {
        setTimeout(_ => color[0].click());

    }

    let size = document.querySelectorAll(".size input");
    if (size.length === 1) {
        setTimeout(_ => size[0].click());

    }*/

    if (ID['reservation-product']) {
        ID['reservation-product'].addEventListener('click', e => {

            if (
                !document.querySelector('input[name="color"]:checked') ||
                !document.querySelector('input[name="size"]:checked')
            ) {
                ID['reservation-error'].innerText = 'Vyberte si velikost a barvu produktu';
                ID['reservation-error'].classList.remove('d-none');
                e.preventDefault();

            } else {
                $('#exampleModal').modal('show');

                let productTitle = ID['product-title'].innerHTML;

                if (ID['select-color'].innerHTML) {
                    productTitle += ' - ' + ID['select-color'].innerHTML;
                }

                if (ID['select-size'].innerHTML) {
                    productTitle += ' / ' + ID['select-size'].innerHTML;

                }

                ID['product-tile'].innerHTML = productTitle;

                ID['reservation-product-id'].value = ID['variant-id'].value;

            }

        });
    }

}

naja.addEventListener('success', (event) => {

    FNC.addCart.changeInputValue(document.getElementsByClassName('amount-input'));

    [...document.getElementsByClassName('variant-input')].forEach(el => {
        el.addEventListener('input', e => {
            if (parseInt(e.target.value) < 0) {
                e.target.value = 0;

            }
            let sum = 0;
            [...document.getElementsByClassName('variant-input')].forEach(el2 => {
                let value = !_.isEmpty(el2.value) ? parseInt(el2.value) : 0;
                sum = sum + value;

            });

            ID['sum'].innerText = sum;

        })
    })

});

/**
 *
 * @returns {null}
 */
FNC.addCart.getSelectColor = () => {
    let color = null

    if (document.querySelector('input[name="color"]:checked')) {
        color = document.querySelector('input[name="color"]:checked').value;

    }

    if (document.querySelector('select[name="color"]')) {
        color = document.querySelector('select[name="color"]').value;

    }

    return color;

};

/**
 * úprava množství přidávaného do košíku
 * @param elements
 * @param increment
 */
FNC.addCart.quantityAdjustment = (elements, increment = true) => {
    [...elements].forEach(el => {

        el.addEventListener('click', () => {
            const
                productId = el.dataset.productId,
                amountEl = ID['amount-' + productId];

            FNC.addCart.setCount(amountEl, increment);

        });

    });

}

FNC.addCart.quantityAdjustmentCoefficient = (elements, increment = true) => {
    [...elements].forEach(el => {
        el.addEventListener('click', () => {
            const element = ID['amount-' + el.dataset.element + '-' + el.dataset.productId];
            FNC.addCart.setCountCoefficient(element, increment);

        });

    });

}

FNC.addCart.changeInputValue = (elements) => {
    if (elements) {
        [...elements].forEach(el => {
            el.oninput = (e) => {
                el.value = el.value === '' ? 0 : el.value;
                if (!_.isEmpty(el.value)) {
                    if (_.isUndefined(el.dataset.type)) {
                        FNC.addCart.setCount(el, null, true);

                    } else {
                        FNC.addCart.setCountCoefficient(el, null, true);

                    }

                }

            };

        });

    }

}



if (ID['add-cart'] || document.getElementsByClassName('add-cart-control')) {


    /** increment kusů */
    FNC.addCart.quantityAdjustment(document.getElementsByClassName('amount-increment'));

    /** decrement kusů */
    FNC.addCart.quantityAdjustment(document.getElementsByClassName('amount-decrement'), false);

    /** increment kusů v položkách koeficientu */
    FNC.addCart.quantityAdjustmentCoefficient(document.getElementsByClassName('amount-increment-coefficient'));

    /** decrement kusů v položkách koeficientu */
    FNC.addCart.quantityAdjustmentCoefficient(document.getElementsByClassName('amount-decrement-coefficient'), false);

    FNC.addCart.changeInputValue(document.getElementsByClassName('amount-input'));


}

if (document.getElementsByClassName('add-to-cart-detail')) {
    [...document.getElementsByClassName('add-to-cart-detail')].forEach(element => {
        element.addEventListener('change', e => {
            const config = !_.isUndefined(e.target.dataset.config)
                ? JSON.parse(e.target.dataset.config)
                : null

            //FNC.addCart.addToCart(config.link, e.target.dataset.variant, e.target.value);

        });

    });

}

/**
 * funkce pro nastavení pročtu kusů do danného element
 * @param element
 * @param increment
 * @param onInput
 */
FNC.addCart.setCount = (element, increment = true, onInput = false) => {
    const config = !_.isUndefined(element.dataset.config)
        ? JSON.parse(element.dataset.config)
        : null

    /*if (!_.isNull(element.dataset.divisionCoefficient)) {
        ID['dimensions-product-info'].hidden = element.value % element.dataset.divisionCoefficient !== 0;

    }*/

    let defaultCount = 1;
    if (!_.isNull(config)) {
        if (config.addCartType === 'edit') {
            defaultCount = 0;

        }

    }

    const
        productId = element.dataset.productId,
        count = element.value !== ''
            ? parseInt(element.value)
            : defaultCount

    if (onInput) {
        element.value = count;

    } else {
        if (increment) {
            element.value = count + 1

            if (parseInt(element.value) > parseInt(element.dataset.variantAvailability) && parseInt(element.dataset.maxAvailabilityInfo)) {
                element.value = element.dataset.variantAvailability;
                if (!_.isNull(ID['max-availability'])) {
                    ID['max-availability'].classList.remove('d-none');

                }
            }

        } else {
            if (count > defaultCount) {
                element.value = count -1;

            }

            if (element.dataset.maxAvailabilityInfo) {
                ID['max-availability'].classList = 'd-none';

            }

        }

    }

    // pokud je nastavené automatické přidávání do košíku tak se zboží hned přidá
    if (_.has(config, 'autoAddCart') && config.autoAddCart) {
        FNC.addCart.addToCart(config.link, element.dataset.variant, element.value);

    }

    if (!_.isUndefined(element.dataset.coefficients)) {
        FNC.addCart.applyCoefficients(element.dataset.coefficients, element.value, productId)

    }

};

FNC.addCart.addToCart = (link, productId, quantity) => {


    naja.makeRequest('POST', link, {
        'productId': productId,
        'quantity': parseInt(quantity)
    }, {
        spinner: false
    }).then(r => {
        let element = ID['amount-' + productId];
        element.classList.add('added')
        setTimeout(() => {
            element.classList.remove('added')
        }, 1000);
    });

};

/**
 * Nastavení hodnot do elementů podle koeficientu
 * @param coefficientsJson
 * @param amount
 * @param productId
 */
FNC.addCart.applyCoefficients = (coefficientsJson, amount, productId) => {
    let coefficients = _.isString(coefficientsJson) ? JSON.parse(coefficientsJson) : coefficientsJson;
    Object.entries(coefficients).forEach(entry => {
        const
            [name, data] = entry,
            count = parseInt(amount) / data.coefficient;

        ID['amount-amount' + name + '-' + productId].value = _.round(count, data.rounding);


    });

};

/**
 * funkce pro nastavení pročtu kusů do elementu koeficientu
 * @param element
 * @param increment
 * @param onInput
 */
FNC.addCart.setCountCoefficient = (element, increment = true, onInput = false) => {
    const
        count = parseInt(element.value),
        type = element.dataset.type,
        coefficients = JSON.parse(element.dataset.coefficients),
        productId = element.dataset.productId;

    if (onInput) {
        element.value = count;

    } else {
        if (increment) {
            element.value = count + 1;

        } else {
            if (count !== 1) {
                element.value = count - 1;

            }

        }

    }

    if (_,isNaN(element.value)) {
        element.value = 1;

    }

    const
        coefficientCount = parseInt(element.value),
        coefficient = coefficients[type].coefficient

    ID['amount-' + productId].value = coefficientCount * coefficient;

    delete coefficients[type];

    FNC.addCart.applyCoefficients(coefficients, ID['amount-' + productId].value, productId);

};

document.addEventListener('DOMContentLoaded', () => {
    if (!ID['velikostni-tabulka']) {
        if (!_.isNull(ID['anchor-wrapp-size-chart'])) {
            ID['anchor-wrapp-size-chart'].style.display = 'none'

        }

    }

    let size = document.getElementsByClassName('size');
    if(!_.isEmpty(size)) {
        if (size.length === 1) {
            if (size[0].localName !== 'div') {
                setTimeout(_ => size[0].click());

            }

        }

    }

    let color = document.getElementsByClassName('color');

    if(!_.isEmpty(color)) {
        if (color.length === 1) {
            if (color[0].localName !== 'div') {
                setTimeout( _ => color[0].click())

            }

        }

    }



})

